import { collection, getFirestore, onSnapshot, query, getDocs } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'stuffTypes/'

function docToInstance(document) {
  const data = document.data()
  return data ? new StuffType(document.id, data.name, data.prefix) : null
}

export default class StuffType {
  constructor(id, name, prefix) {
    this.id = id
    this.name = name
    this.prefix = prefix
  }
  
  static initOne() {
    return new StuffType(null, 'Nouveau type', 'Un')
  }

  async save() {
    const data = {
      name: this.name,
      prefix: this.prefix
    }

    if (this.id) {
      await catalogueCommands.stuffType.update(this.id, data)
    } else {
      const result = await catalogueCommands.stuffType.create(data)
      this.id = result.id
    }
    return this
  }
  async delete() {
    await catalogueCommands.stuffType.delete(this.id)
  }

  static async listenAll(callback) {
    const docsQuery = query(collection(db, await getCollectionPath(collectionName)))
    onSnapshot(docsQuery, snapshot => {
      const list = []
      snapshot.forEach(document => {
        list.push(docToInstance(document))
      })
      callback(list)
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }
}